import fetch from './index'
import { enrichWithAiAudit } from './aiAuditMock'
// STAGE=local 下让列表 / 详情补 aiAudit 字段；非 local 时 enrichWithAiAudit 为直通
function wrapWithAiAudit(result: any, detail = false): any {
  if (!result) return result
  if (Array.isArray(result?.models)) {
    return { ...result, models: result.models.map((m: any) => enrichWithAiAudit(m, false)) }
  }
  if (Array.isArray(result?.records)) {
    return { ...result, records: result.records.map((m: any) => enrichWithAiAudit(m, false)) }
  }
  if (detail && typeof result === 'object') {
    return enrichWithAiAudit(result, true)
  }
  return result
}

export function getFactoriesList(params): any {
  return fetch.get('/eps/factories/list', { params })
}
// 查询/筛选场景用：含停用工厂(后端沉底排序)。录入场景必须用 getAllFactoriesList——新建单据不能挂停用工厂
export function getAllFactoriesListWithDisabled(): any {
  return fetch.get('/eps/factories/all/list', { params: { containsDisabled: true } })
}
// 与上面配对的下拉文案:停用工厂加后缀,让"为什么它排最后"一眼可见
export function factoryOptionLabel(record): string {
  return record?.status === 0 ? `${record?.name}（已停用）` : record?.name
}
// 获取全部工厂
export function getAllFactoriesList(): any {
  return fetch.get('/eps/factories/all/list')
}
// 新的带启用/停用的工厂查询
export function queryFactoryPage(params): any {
  return fetch.post('/eps/factories/manage/page', params)
}
// 工厂启用停用
export function updateFactoryStatus(params): any {
  return fetch.post('/eps/factories/update/status', params)
}
// 工厂排序
export function putFactorySort(params): any {
  return fetch.put('/eps/factories/sort', params)
}
 
export function delFactory(id) {
  return fetch.delete(`/eps/factories/${id}`)
}

export function addFactory(params) {
  return fetch.post('/eps/factories', params)
}

export function editFactory(params) {
  return fetch.put('/eps/factories', params)
}
// 创建工厂单
export function createFactoryOrder(params) {
  return fetch.post('/eps/factory/order', params)
}
// 编辑工厂单
export function editFactoryOrder(params) {
  return fetch.put('/eps/factory/order', params)
}
// 查询工厂单
/** 「载入最近石资料」：按 listing 取最近一单的款号+纯资料石行（无来源单 data 为 null） */
export function getLatestStoneSourceByListing(platformCommodityId): any {
  return fetch.get('/eps/factory/order/stoneSource/latestByListing', { params: { platformCommodityId } })
}

export function queryFactoryOrder(params): any {
  return fetch.post('/eps/factory/order/page', params).then(r => wrapWithAiAudit(r, false))
}
// 工厂单刷新毛利率
export function refreshFactoryOrderGross() {
  return fetch.post('/eps/factory/order/refresh/gross/margin', {})
}
// 工厂单详情
export function getFactoryOrderDetail(params): any {
  return fetch.get('/eps/factory/order/info', { params }).then(r => wrapWithAiAudit(r, true))
}
// 批量查工单商品的工单详情
export function getBatchFactoryOrderDetail(params) {
  return fetch.post('/eps/factory/order/commodityIds', params)
}
// 删除取消工厂单
export function editFactoryOrderStatus(id, status) {
  return fetch.post('/eps/factory/order/update/status', {id, status})
}
// 审核工厂单，操作回货
export function auditFactoryOrder(id, auditStatus) {
  return fetch.post('/eps/factory/order/update/audit/status', { id, auditStatus })
}
// 批量审核
export function auditBatchFactoryOrder(ids,auditStatus) {
  return fetch.post('/eps/factory/order/batch/update/audit/status', { ids, auditStatus })
}
// 导出工厂单
export function exportFactoryOrder(params) {
  return fetch.post('/export/records/factory/order', params)
}
// 导入修改
export function importEditFactoryOrder(params) {
  return fetch.post('eps/factory/order/import/update', params)
}
// 导入工厂单
export function importFactoryOrder(params) {
  return fetch.post('/eps/factory/order/import', params)
}
// 工厂单审核人列表
export function getFactoryOrderReviewer(): any {
  return fetch.get('/staffs/factory/order/reviewer')
}
// 维修问题查询
export function getFactoryRepairQuestion(): any {
  return fetch.get('/repair/reason/type')
}
// 维修问题新增
export function addFactoryRepairQuestion(params): any {
  return fetch.post('/repair/reason/type', params)
}
// 维修问题编辑
export function editFactoryRepairQuestion(params): any {
  return fetch.put('/repair/reason/type', params)
}
// 维修问题删除
export function delFactoryRepairQuestion(id): any {
  return fetch.delete(`/repair/reason/type/${id}`)
}
// 维修问题排序
export function sortFactoryRepairQuestion(params): any {
  return fetch.put('/repair/reason/type/sort', params)
}
// 创建维修单
export function addRepariReasonTicket(params): any {
  return fetch.post('/repair/reason/ticket', params)
}
// 编辑维修单
export function editRepariReasonTicket(params): any {
  return fetch.put('/repair/reason/ticket', params)
}
// 查询维修单
export function getRepariReasonTicketList(params): any {
  return fetch.post('/repair/reason/ticket/page', params)
}
// 跟进维修单
export function followRepariReasonTicket(id): any {
  return fetch.put(`/repair/reason/ticket/follow/${id}`)
}
// 回货维修单
export function returnRepariReasonTicket(id): any {
  return fetch.put(`/repair/reason/ticket/return/${id}`)
}
// 取消维修单
export function cancelRepariReasonTicket(id): any {
  return fetch.put(`/repair/reason/ticket/cancel/${id}`)
}
// 完成维修单
export function finishRepariReasonTicket(id): any {
  return fetch.put(`/repair/reason/ticket/finish/${id}`)
}
// 获取工单商品石资料名称自定义
export function getFactoryOrderStoneCustom(): any {
  return fetch.get('/eps/factory/order/stone/name/custom')
}
// 编辑工单商品石资料名称自定义
export function editFactoryOrderStoneCustom(params): any {
  return fetch.post('/eps/factory/order/stone/name/custom', params)
}
// 工单进度批量编辑审核人
export function editBatchFactoryOrderReviewer(params): any {
  return fetch.post('/eps/factory/order/batch/update/reviewer', params)
}
// 工单进度批量取消  
export function cancelBatchFactoryOrder(params): any {
  return fetch.post('/eps/factory/order/batch/cancelled', params)
}
// 获取工单订单号
export function getFactoryOrderNo(): any {
  return fetch.get('/eps/factory/order/orderNo')
}
// 获取维修单号
export function getRepairOrderNo(): any {
  return fetch.get('/repair/reason/ticket/orderNo')
}
// 维修单重做信息列表(query 传 ticketIds,逗号分隔;返回 Map<ticketId, 重做对象数组>)
export function getRepairTicketRedoList(ticketIds: (number | string)[]): any {
  return fetch.post('/repair/reason/ticket/redo/list', {}, { params: { ticketIds: ticketIds.join(',') } })
}
// 维修单退款信息列表(query 传 ticketIds,逗号分隔;返回 Map<ticketId, 退款对象数组>)
export function getRepairTicketRefundList(ticketIds: (number | string)[]): any {
  return fetch.post('/repair/reason/ticket/refund/list', {}, { params: { ticketIds: ticketIds.join(',') } })
}
// 定制单补货出库
export function outputReplenishmentOrder(params): any {
  return fetch.post('/storage/outputs/batch/replenishment', params)
}
// 新的工单定制单批量出库
export function outputReplenishmentOrderNew(params): any {
  return fetch.post('/storage/outputs/new/batch/replenishment', params)
}
// 工单进度列表
export function getFactoryOrderProgress(): any {
  return fetch.get('/factory/order/progress')
}
// 新增工单进度
export function addFactoryOrderProgress(params): any {
  return fetch.post('/factory/order/progress', params)
}
// 编辑工单进度
export function editFactoryOrderProgress(params): any {
  return fetch.put('/factory/order/progress', params)
}
// 删除工单进度
export function delFactoryOrderProgress(code): any {
  return fetch.delete(`/factory/order/progress?code=${code}`)
}
// 订单数据分析
export function getFactoryOrderAnalysisList(params): any {
  return fetch.post('/eps/factory/order/analysis/report', params)
}
// 订单数据分析导出
export function exportFactoryOrderAnalysisList(params): any {
  return fetch.post('/export/records/eps/factory/order/analysis/report', params)
}
// 主石分析数据
export function getFactoryOrderMasterCatAnalysis(params): any {
  return fetch.post('/eps/factory/order/analysis/master/category/chart', params)
}
// 形状分析数据
export function getFactoryOrderMasterShapeAnalysis(params): any {
  return fetch.post('/eps/factory/order/analysis/shape/chart', params)
}
// 成色分析数据
export function getFactoryOrderMetalColorAnalysis(params): any {
  return fetch.post('/eps/factory/order/analysis/metal/color/chart', params)
}
// 款式数据
export function getFactoryOrderAnalysisDesign(params): any {
  return fetch.post('/eps/factory/order/analysis/design/report', params)
}
// 款式数据导出
export function exportFactoryOrderAnalysisDesign(params): any {
  return fetch.post('/export/records/eps/factory/order/analysis/design/report', params)
}
// 聚合属性名
export function getFeatureNameAlias(params): any {
  return fetch.get('/category/features/name/alias', { params })
}
// 综合分析 
export function getFactoryOrderAnalysisChart(params): any {
  return fetch.post('/eps/factory/order/analysis/chart', params)
}
// listing分析
export function getFactoryOrderListingAnalysisChart(params): any {
  return fetch.post('/eps/factory/order/analysis/listing/chart', params)
}
// 工单分析
export function getFactoryOrderAnalysisOptions(params): any {
  return fetch.post('/eps/factory/order/analytics/options', params)
}
// 批量修改工单标记
export function putFactoryOrderBatchFlagStatus(params): any {
  return fetch.put('/eps/factory/order/batch/update/flag/status', params)
}
// 导出设置查询
export function getExportColumnTemplate(type): any {
  return fetch.get(`/export/column/template?type=${type}`)
}
// 导出设置新增/编辑
export function postExportColumnTemplate(params): any {
  return fetch.post('/export/column/template', params)
}
// 导出设置删除
export function delExportColumnTemplate(id): any {
  return fetch.delete(`/export/column/template?id=${id}`)
}
// 批量编辑物流渠道
export function editBatchOrderLogisticsId(params): any {
  return fetch.post('/eps/factory/order/batch/update/logistics', params)
}
// 批量编辑小包裹物流渠道
export function editBatchOrderExpressId(ids, expressId): any {
  return fetch.put(`/eps/factory/order/batch/update/expressId?ids=${ids}&expressId=${expressId}`)
}
// 批量编辑物流单号
export function editBatchOrderLogisticsNo(params): any {
  return fetch.post('/eps/factory/order/batch/update/logisticsNo', params)
}
// 批量修改工单标签
export function editBatchFactoryOrderTags(params): any {
  return fetch.put('/eps/factory/order/batch/update/tag/status', params)
}
// 工单定制需求模板
export function addFactoryOrderCustomRemark(params): any {
  return fetch.post('/factory/order/custom/remark/template', params)
}

export function getFactoryOrderCustomRemark(params): any {
  return fetch.get('/factory/order/custom/remark/template', { params })
}

export function editFactoryOrderCustomRemark(params): any {
  return fetch.put('/factory/order/custom/remark/template', params)
}

export function delFactoryOrderCustomRemark(id): any {
  return fetch.delete(`/factory/order/custom/remark/template?id=${id}`)
}

// 维修进度导出
export function exportRepairTicket(params): any {
  return fetch.post('/export/records/repair/reason/ticket/report', params)
}

// 维修数据分析
export function exportRepairTicketAnalysis(params): any {
  return fetch.post('/repair/reason/ticket/analysisRepair', params)
}

// 导入工单石资料
export function importFactoryOrderStone(params): any {
  return fetch.post('/eps/factory/order/import/stone', params)
}
// 物流快递信息订阅借口
export function setFactoryOrderExpressSubscribe(params): any {
  return fetch.post('/express/subscribe', params)
}
// 查询物流快递最新信息
export function getFactoryOrderExpressNewInfo(params): any {
  return fetch.post('/express/query', params)
}
// 查询物流快递详细信息
export function getFactoryOrderExpressDetailInfo(params): any {
  return fetch.post('/express/detail/query', params)
}
// 石资料导出
export function exportFactoryOrderStone(params): any {
  return fetch.post('/export/records/order/stone', params)
}
// 聚合石资料导出
export function exportFactoryOrderSumStone(params): any {
  return fetch.post('/export/records/order/sum/stone', params)
}
// 新增工单对话
export function addFactoryOrderDialog(params): any {
  return fetch.post('/factory/order/dialog', params)
}
// 编辑工单对话----只有未处理时，才能编辑，必须创建人才能编辑，其他人看不到编辑按钮
export function editFactoryOrderDialog(params): any {
  return fetch.put('/factory/order/dialog', params)
}
// 处理工单对话----只有未处理时，才能处理
export function dealFactoryOrderDialog(params): any {
  return fetch.put('/factory/order/dialog/deal', params)
}
// 删除工单对话----只有未处理时，才能删除
export function delFactoryOrderDialog(dialogId): any {
  return fetch.delete(`/factory/order/dialog/${dialogId}`)
}

// ---- 工厂沟通记录（双端可见，与内部沟通记录隔离）----
export function listCommunicateLogs(factoryOrderId): any {
  return fetch.get(`/factory/communicate/list/${factoryOrderId}`)
}
export function addCommunicateLog(params): any {
  return fetch.post('/factory/communicate', params)
}
export function editCommunicateLog(params): any {
  return fetch.put('/factory/communicate', params)
}
export function handleCommunicateLog(logId): any {
  return fetch.put(`/factory/communicate/handle/${logId}`)
}
export function deleteCommunicateLog(logId): any {
  return fetch.delete(`/factory/communicate/${logId}`)
}
export function getCommunicateUnhandledCount(): any {
  return fetch.get('/factory/communicate/unhandled-count')
}
export function getCommunicateUnhandledOrderIds(): any {
  return fetch.get('/factory/communicate/unhandled-order-ids')
}
export function syncDialogToCommunicate(params): any {
  return fetch.post('/factory/communicate/sync-from-dialog', params)
}

// 工厂沟通记录 → 同步至运营(工单沟通记录) 反向同步
export function syncCommunicateToDialog(params): any {
  return fetch.post('/factory/communicate/sync-to-dialog', params)
}